export const initialFilters = {
  objeto: '',
  notWord: '',
  geoType: 'estado' as 'estado' | 'região' | 'localização',
  region: null as { label: string; value: string } | null,
  states: [] as number[],
  cities: [] as number[],
  address: '',
  radius: 10000,
  situations: [] as number[],
  status: [] as boolean[],
  validityStart: '',
  validityEnd: '',
  orgao: '',
  esfera: [] as number[],
  publicationStart: '',
  publicationEnd: '',
};
